module.exports = __webpack_public_path__ + "static/img/stained_glass_print.56bd4a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/prints/stained_glass_print.jpg
// module id = zYOU
// module chunks = 1